import Badge from "@/components/base/Badge";
import {
  COMPTE_STATUT_ICONS,
  COMPTE_STATUT_LABELS,
  COMPTE_STATUT_TONES,
  type CompteStatut,
} from "../data/types";

interface StatutBadgeProps {
  statut: CompteStatut;
}

export default function StatutBadge({ statut }: StatutBadgeProps) {
  return (
    <Badge tone={COMPTE_STATUT_TONES[statut]} icon={COMPTE_STATUT_ICONS[statut]}>
      {COMPTE_STATUT_LABELS[statut]}
    </Badge>
  );
}